import { Flow } from 'signup-constants/Flow';
import { preFillHubInterestGSWH } from '../../experiments/gswhV1/gswhUtils';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { setFlow } from '../../store/flow/action-creators';
import { getIsMobile } from '../../utils/deviceUtils';
import { isFlow } from '../../utils/isFlow';
import { Step } from '../../views/Step';
export const BranchACQ140VariantB = {
  name: 'BranchACQ140VariantB',
  stateCheck: () => {
    return false; //getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0140);
  },
  rebuildFlow: (flow, state, dispatch) => {
    let preVerification = [Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.HubOption, Step.BusinessGoals, Step.AhaMoment, Step.LandingPage, Step.CodeVerification];

    if (!getIsMobile() && !isFlow(Flow.Crm)) {
      preVerification = NextStepManager.removeSteps(Step.HubOption)(preVerification);
    }

    if (!isFlow(Flow.Crm)) {
      preFillHubInterestGSWH(dispatch);
    }

    const postVerification = [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
    const postAccountCreationSteps = getIsMobile() ? [Step.MobileAppPrompt] : [];
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerification, ...postAccountCreationSteps];
    dispatch(setFlow(nextSteps, preVerification, postVerification, postAccountCreationSteps, getFlowSteps().postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};